import { readJsonCookie, writeJsonCookie } from '../../../utils/jsonCookie'

export type NotificationSort = 'date_desc' | 'date_asc' | 'alpha_asc' | 'alpha_desc'

export interface NotificationPrefs {
    unreadOnly: boolean
    sort: NotificationSort
}

const NOTIFICATION_SORT_VALUES: NotificationSort[] = ['date_desc', 'date_asc', 'alpha_asc', 'alpha_desc']

const NOTIFICATION_PREFS_COOKIE_NAME = 'notifications-prefs'

export function getDefaultNotificationPrefs(): NotificationPrefs {
    return {
        unreadOnly: false,
        sort: 'date_desc',
    }
}

export function readNotificationPrefs(): NotificationPrefs {
    const defaultPrefs = getDefaultNotificationPrefs()
    const parsedValue = readJsonCookie(NOTIFICATION_PREFS_COOKIE_NAME)

    if (!parsedValue) {
        return defaultPrefs
    }

    // Старый формат хранил sortDesc: boolean — конвертируем в режим сортировки.
    let sort = defaultPrefs.sort
    if (NOTIFICATION_SORT_VALUES.includes(parsedValue.sort)) {
        sort = parsedValue.sort
    } else if (typeof parsedValue.sortDesc === 'boolean') {
        sort = parsedValue.sortDesc ? 'date_desc' : 'date_asc'
    }

    return {
        unreadOnly: typeof parsedValue.unreadOnly === 'boolean' ? parsedValue.unreadOnly : defaultPrefs.unreadOnly,
        sort,
    }
}

export function writeNotificationPrefs(prefs: NotificationPrefs) {
    writeJsonCookie(NOTIFICATION_PREFS_COOKIE_NAME, prefs, 'notification prefs')
}
